module.exports = __webpack_public_path__ + "static/img/powder.63d982bd.png";